export default __webpack_public_path__ + "static/media/frontpage.0b3eb31c.txt";